module.exports = __webpack_public_path__ + "static/media/stable.b2241ecd.svg";